import { ViewModelForm } from 'gw-portals-viewmodel-react';
import React, { useContext, useEffect } from 'react';
import { useValidation } from 'gw-portals-validation-react';
import SgNameDetails from 'sg-name-details';
import { SgDate, SgDateInputTypes } from 'sg-date';
import { SgSubmissionUtil, SgCpcUtilService } from 'saga-modules';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import metadata from './SgSpmPersonalDetails.metadata.json5';
import messages from './SgSpmPersonalDetails.messages';

function SgSpmPersonalDetails(props) {
    const {
        id,
        modelVM,
        showErrors,
        driverIndex,
        isPolicyHolder,
        showDuplicatedPersonError,
        updateData,
        path,
        onValidate: onValidateParent,
        setShowErrors,
        messageParams
    } = props;

    const {
        isComponentValid,
        onValidate
    } = useValidation(id);
    const translator = useContext(TranslatorContext);
    const commonProps = {
        modelVM, setShowErrors, showErrors, updateData
    };
    const driverModelPath = `${path}[${driverIndex}]`;
    const driverDetailsPath = isPolicyHolder ? 'baseData.motorAccountHolder' : `${driverModelPath}.person`;
    const adobeIdSuffix = isPolicyHolder ? 'PolicyHolder' : 'AdditionalDriver';

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    useEffect(() => {
        const isDobValid = _.get(modelVM, `${driverDetailsPath}.dateOfBirth.aspects.valid`);
        if (isDobValid && isPolicyHolder) {
            SgCpcUtilService.getCpcData(modelVM);
        }
    }, [driverDetailsPath, isPolicyHolder, _.get(modelVM, 'baseData.motorAccountHolder.dateOfBirth.value')]);

    const overrides = {
        policyholderEsolMessage: {
            visible: SgSubmissionUtil.isResolQuote(modelVM),
            content: <span>{translator(messages.EsolMessage)}</span>
        },
        nameDetailsComponent: {
            name: 'nameDetailsComponent',
            controller: SgNameDetails,
            path: driverDetailsPath,
            messageParams,
            ...commonProps,
            suffix: adobeIdSuffix,
            isPolicyHolder,
            shouldCallNewCustomerPermission: true
        },
        maritalStatus: {
            visible: isPolicyHolder === true
        },
        dateOfBirth: {
            path: `${driverDetailsPath}.dateOfBirth`,
            customId: isPolicyHolder ? 'dateOfBirth' : 'additionalDriverDateOfBirth',
            label: translator(messages.DateOfBirth, messageParams),
            onValidate: onValidate,
            showErrors,
            modelVM,
            updateData,
            datePickerTypeDesktop: SgDateInputTypes.DAY_MONTH_YEAR_INPUTS,
            autoCompleteYear: true
        },
        duplicatedDriverError: {
            visible: showDuplicatedPersonError ? showDuplicatedPersonError() === true && showErrors : false,
            className: 'FieldMessage_error sgAdditionalDriversError'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        },
        resolveComponentMap: {
            SgNameDetails,
            SgDate
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            showErrors={showErrors}
            onModelChange={updateData}
            onValidationChange={onValidate}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default SgSpmPersonalDetails;
